/**
 * @file
 * Global utilities.
 *
 */

/* global jQuery, Drupal, document */
import map from 'lodash/fp/map';

import bootstrap from './cidrap.bootstrap';
import mainMenu from './cidrap.main-menu';
import parallax from './cidrap.parallax';
import publishTime from './cidrap.publish-time';
import scroll from './cidrap.scroll';
import a11y from './cidrap.a11y';

(($, Drupal) => {
  /* eslint-disable no-param-reassign */
  Drupal.theme.ajaxProgressBar = $element => $('<div class="ajax-progress ajax-progress-bar"></div>').append($element);
  Drupal.behaviors.cidrap_theme = {
    attach: () => {
      $('body').once('cidrap-theme').each(() => {
        bootstrap($);
        mainMenu($);
        parallax($);
        publishTime($);
        scroll($);

        $('#mc_embed_signup .email-button-wrapper button').on('click touch', (evt) => {
          const $form = $(evt.target).closest('form');
          const $newsletters = $form.find('[type="checkbox"]:checked');
          if ($newsletters.length === 0) {
            evt.preventDefault();
            evt.stopPropagation();
            $form.find('#mce-responses').first().after('<div class="mce_inline_error">Please select at least one newsletter.</div');
            return false;
          } else {
            $form.find('#mce-responses').first().next('.mce_inline_error').remove();
          }
        });

        /* eslint-disable */
        // Newsletter select-all checkbox
        $('#newsletters-select-all').click(function(event) {
          if (this.checked) {
            // Iterate each checkbox
            $('.input-group.newsletters :checkbox').each(function() {
                this.checked = true;
            });
          } else {
            $('.input-group.newsletters :checkbox').each(function() {
                this.checked = false;
            });
          }
        });
        /* eslint-enable */

        // Remove author field from news brief listing on homepage
        if (document.querySelector('.paragraph--type-news-briefs-listing') && (document.querySelector('body.path-frontpage'))) {
          map((author) => {
            author.remove();
          }, document.querySelectorAll('.paragraph--type-news-briefs-listing .field--name-field-authors'));
        }

        $('.block-cidrap-persistent-newsletter .toggle-newsletter').on('click touch', (evt) => {
          evt.preventDefault();
          $(evt.target).closest('.block').toggleClass('is-open');
        });

      });
    },
  };
})(jQuery, Drupal);
